module.exports = __webpack_public_path__ + "1ba29246be1b731d5eaa3a80e9cc4ca4.jpg";